import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const VideoFileIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "VideoFile",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M30.03 10.54a2 2 0 0 0-.12-.35s0-.07 0-.07c-.07-.12-.15-.21-.24-.3L22.15 2.3c-.08-.07-.18-.14-.29-.19s-.08 0-.08 0c-.08-.04-.17-.07-.27-.1s-9.72 0-9.72 0a4.22 4.22 0 0 0-4.22 4.12v3.42c-3.23.68-5.63 3.5-5.63 6.89s2.39 6.21 5.58 6.88h.05v2.94c0 2.21 1.74 3.75 4.22 3.75h14.06c2.48 0 4.22-1.54 4.22-3.75V10.54h-.03ZM6.62 12.93l.98.54 5.63 3.24-2.85 1.63-2.81 1.63-.98.54.04-7.58Zm20.63 13.35c0 .77-.76.98-1.41.98H11.78c-.64 0-1.41-.17-1.41-.98v-2.93c3.23-.68 5.63-3.5 5.63-6.89s-2.39-6.21-5.58-6.88h-.05V6.12c0-.78.63-1.41 1.41-1.41h7.97v5.16c0 1.29 1.05 2.34 2.34 2.34h5.16v14.06Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M23 28.14 28.14 23 23 17.86z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M23 29.29c-.15 0-.3-.03-.44-.09-.43-.18-.71-.59-.71-1.06V17.85c0-.46.28-.88.71-1.06s.92-.08 1.25.25l5.14 5.14c.45.45.45 1.17 0 1.62l-5.14 5.14c-.22.22-.51.33-.81.33Zm1.14-8.67v4.77l2.38-2.38-2.38-2.38Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M17.86 29.29H5.29c-1.89 0-3.43-1.54-3.43-3.43V5.29c0-1.89 1.54-3.43 3.43-3.43H19c.3 0 .59.12.81.33l9.14 9.14c.45.45.45 1.17 0 1.62s-1.17.45-1.62 0l-8.81-8.81H5.29c-.63 0-1.14.51-1.14 1.14v20.57c0 .63.51 1.14 1.14 1.14h12.57a1.14 1.14 0 1 1 0 2.28Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M28.14 17.86c-.63 0-1.14-.51-1.14-1.14v-3.43h-5.71c-1.89 0-3.43-1.54-3.43-3.43V3a1.14 1.14 0 1 1 2.28 0v6.86c0 .63.51 1.14 1.14 1.14h6.86c.63 0 1.14.51 1.14 1.14v4.57c0 .63-.51 1.14-1.14 1.14Z"
      })]
    })
  }));
};
VideoFileIcon.displayName = 'VideoFileIcon';